import type {DesignModuleSpecJson} from '../data/contracts';

/** GAP-39 (29.10.2026) : une capture prise dialogue ouvert (« Paramètres du foyer » → dialogue « Votre foyer ») est l'écran de la page
 * native qui réalise ce dialogue (formulaire natif du même titre), pas un écran à recompiler en gabarit ni une pièce à ignorer.
 * Le dialogue ouvert est `dialog[open]` ou `[role=dialog][aria-modal=true]` ; à défaut (capture sans attribut `open`), le seul
 * `<dialog>` qui porte un contenu. Retourne la clé de la page dont le formulaire natif porte exactement ce titre, si elle est unique. */
export function dialogScreenTitle(html:string):string|null{
 const doc=new DOMParser().parseFromString(html,'text/html');
 const open=Array.from(doc.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"]'));
 const filled=Array.from(doc.querySelectorAll('dialog')).filter(dialog=>dialog.querySelector('input,select,textarea'));
 const dialog=open.length===1?open[0]:!open.length&&filled.length===1?filled[0]:null;
 if(!dialog)return null;
 const labelled=dialog.getAttribute('aria-labelledby'),heading=(labelled?doc.getElementById(labelled):null)??dialog.querySelector('h1,h2,h3,legend');
 const title=heading?.textContent?.replace(/\s+/g,' ').trim()??'';
 return title||null;
}
export function dialogScreenPage(spec:DesignModuleSpecJson,html:string):string|null{
 const title=dialogScreenTitle(html);if(!title)return null;
 const pages=((spec.pages??[]) as {key:string;screen?:{blocks?:{dialogForm?:{title?:string}}[]}}[]).filter(page=>page.screen?.blocks?.some(block=>block.dialogForm?.title?.replace(/\s+/g,' ').trim()===title));
 return pages.length===1?pages[0].key:null;
}
